import { render } from "./CreatePayrollPeriod.vue?vue&type=template&id=7e4c3ac5&scoped=true"
import script from "./CreatePayrollPeriod.vue?vue&type=script&lang=js"
export * from "./CreatePayrollPeriod.vue?vue&type=script&lang=js"

import "./CreatePayrollPeriod.vue?vue&type=style&index=0&id=7e4c3ac5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4c3ac5"]])

export default __exports__